import React from 'react';

const Team200Page: React.FC = () => {
  return (
    <div className="team200-page">
      <div className="team200-container">
        <h1>Team 200 Campaign</h1>
        <p>
          Join our Team 200 campaign by signing up for a $100 monthly donation for one year.
          Every contribution helps us finish the TDS Event Center.
        </p>
        <div className="team200-card">
          <img
            src="/team200.png"
            alt="Team 200 campaign"
            className="team200-image"
          />
          <p className="team200-benefit">
            Team 200 members receive 2 years of membership free once the building is complete.
          </p>
          <p className="team200-note">
            You will complete the $100 monthly signup on the donation page.
          </p>
          <a
            className="contact-button contact-button-primary team200-donate"
            href="https://secure.qgiv.com/for/friendsofthefair-communitybuilding/?utm_id=97758_v0_s00_e0_tv2_a1den1nmxgth1u"
            target="_blank"
            rel="noreferrer"
          >
            Click here to donate $100 / month
          </a>
        </div>
      </div>
    </div>
  );
};

export default Team200Page;
